import React from 'react';
import CustomHead from '../components/CustomHead';
import StandardLayout from '../components/StandardLayout';
import toast, { Toaster } from 'react-hot-toast';
import { Container } from '../components/Container';
import SvgIcon from '../components/icons/SvgIcon';

export default function ContactUs({}) {
  return (
    <StandardLayout
      head={
        <CustomHead
          title="TopHouse - Contact Us"
          description="Contact Us Information"
        />
      }
    >
      <Container>
        <div className="flex flex-[2_2_0%] flex-col items-center max-w-screen-md m-auto">
          <h1 className="text-center mt-14 mb-14">Contact Us</h1>
          <p className="text-gray-500 text-md text-center mb-6 text-2xl">
            Whether you{"'"}re a home buyer, seller, agent, investor, or simply
            a real estate enthusiast, we{"'"}d love to hear from you.
          </p>
          <p className="text-gray-500 text-md text-center mb-6 text-2xl">
            Please reach out to us at the email address below:
          </p>
          <button
            className="mt-6 btn hover:bg-darkGray"
            onClick={() => {
              navigator.clipboard.writeText('info@tophouse.com');
              toast.success('Email copied to clipboard');
            }}
          >
            <span>
              <SvgIcon name="TbClipboard" className="mr-5 mb-1 inline" />
              info@tophouse.com
            </span>
          </button>
        </div>
      </Container>
      <Toaster />
    </StandardLayout>
  );
}
